import React, {useEffect, useState, useContext} from "react";
import {Redirect} from 'react-router-dom'
import justcastApi from '../api/justcast';
import {uploadHandler} from '../api/doUploader'
import ShowPageHeader from '../components/PageHeader/ShowPageHeader';
import ImageUploadForm from '../components/ImageUploadForm';
import {Context as ScreenContext} from '../context/ScreenContext'
import {Context as AlertContext} from '../context/AlertContext'
import {Context as MenuContext} from '../context/MenuContext'
import { Spinner, ListGroup, ListGroupItem, Row, Card, CardBody } from 'reactstrap';
import SimpleMedia from '../components/SimpleMedia'
import ToastMessage from "../components/ToastMessage";
import { PhotoUpload, ArtworkUploadModal } from "../components/episode/assets";

const ShowArtwork = (props) => {
  const {addWithTimeout} = useContext(AlertContext);
  const menuContext = useContext(MenuContext);
  const screenContext = useContext(ScreenContext)
  const id = props.match.params.id;
  const [showName, setShowName] = useState('');
  const [denied, setDenied] = useState(false);

  const [artworkModalOpen, setArtworkModalOpen] = useState(false);
  const [imageUploadErrors, setImageUploadErrors] = useState([]);
  const [artworkSrc, setArtworkSrc] = useState("https://placehold.co/150x150") //
  const [artworkId, setArtworkId] = useState(null);
  const [toastShow, setToastShow] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [toastTitle, setToastTitle] = useState(null);
  const [toastTimeoutId, setToastTimeoutId] = useState(null);
  const [loadingChange, setLoadingChange] = useState(null);

  const handleSetToast = ({title, message}) => {
    setToastShow(true);
    setToastTitle(title)
    setToastMessage(message);

    if(toastTimeoutId) {
      clearTimeout(toastTimeoutId)
    };

    const _timeOutId = setTimeout(() => {
      setToastShow(false);
    }, 2000)

    setToastTimeoutId(_timeOutId)
  }

  const toggleToast = () => {
    setToastShow(!toastShow);
  }

  const toggleArtworkModal = () => {
    setArtworkModalOpen(!artworkModalOpen);
  }

  const setArtworkErrors = (errors) => {
    setImageUploadErrors(errors);
    setArtworkModalOpen(true);
  }

  const uploadArtwork = (file) => {
    setLoadingChange("artwork");
    const formData = new FormData();
    formData.append("name", "name");
    formData.append("type", "artwork");
    formData.append("file", file)

    justcastApi.post(`/v2/shows/${id}/artwork`, formData)
    .then((res) => {
      // alert("File upload sccuess");
      const { file_url, file_id } = res.data;
      if(file_url) {
        setArtworkSrc(file_url)
        setArtworkId(file_id)
      }

      handleSetToast({title: "Podcast artwork", message: "Image upload success"})
      setLoadingChange(null)
    })
    .catch((err) => {
      handleSetToast({title: "Podcast artwork", message: "Image upload failed"})
      setLoadingChange(null)
    })
  }

  useEffect(() => {
    screenContext.startFetching();
    justcastApi.get(`/v1/shows/${id}`)
    .then((res) => {
      const name = res.data.podcast_title;

      menuContext.setSettingsMenus({
        title: 'Artwork',
        subtitle: name,
        currentPageId: 'settings',
        currentTabId: 'artwork',
        showId: id,
        landingPageUrl: res.data.landing_page_url,
        websiteUrl: res.data.player_page_link,
        rssFeed: res.data.rss_feed,
        passwordProtected: res.data.is_password_protected,
        advancedPrivate: res.data.is_advanced_private_feed,
        isPrivate: res.data.is_private,
        isPrivateShow: res.data.is_private_show,
        skill_podcast_website: res.data.skill_podcast_website
      });

      setShowName(name);
      setArtworkSrc(res.data.artwork_url || "https://placehold.co/150x150")
      screenContext.finishFetching();
    })
    .catch((err) => {
      screenContext.finishFetching();
      setDenied(true)
      console.log(err)
    })
  }, [id])

  if(denied) {
    return <Redirect to="/dashboard"/>
  }

  if(screenContext.state.loading) {
    return null
  }

  return (
    <div className="container-fluid">
      <ToastMessage
        toggle={toggleToast}
        show={toastShow}
        title={toastTitle}
        message={toastMessage}
      />
      <ArtworkUploadModal
        modal={artworkModalOpen}
        toggle={toggleArtworkModal}
        errors={imageUploadErrors}
      />
      <ListGroup>
        <ListGroupItem>
          <PhotoUpload
            src={artworkSrc}
            setArtworkModalOpen={setArtworkErrors}
            uploadFile={uploadArtwork}
            artworkId={artworkId}
            deleteFile={null}
            loading={loadingChange === "artwork"}
          />
        </ListGroupItem>
      </ListGroup>
    </div>
  )
}

export default ShowArtwork;